// extracted by mini-css-extract-plugin
module.exports = {"containerRating":"WcCJ7pO56Kr2bnClTE5F4"};